import type { CategoryNodeDto, IntegrationCategoriesDto } from "../../types";

export function buildTree(integrationsWithCategories: IntegrationCategoriesDto[]) {

    integrationsWithCategories.forEach(i => {

        const build = (node: CategoryNodeDto): number => {
            node.children = i.categories.filter(x => x.parentId === node.id);
            
            let count = node.productCount || 0;
            node.children.forEach(c => {
                count += build(c);
            });

            return node.productCount = count;
        }

        const rootItems = i.categories.filter(x => !x.parentId);

        let count = 0;
        rootItems.forEach(c => {
            count += build(c);
        });

        i.productCount = count;
        i.categories = rootItems;
    });
}